success_callback = function(payload){
    console.log(payload.documentElement)
    
    document.getElementById("main_card").innerHTML = payload.documentElement.outerHTML 

    
    var arr = document.getElementById("main_card").getElementsByTagName('script')
    for (var n = 0; n < arr.length; n++){
        const script = document.createElement("script");
        if(arr[n].getAttribute("data-client-token")){
            script.setAttribute("data-client-token",arr[n].getAttribute("data-client-token"))
        }
        script.type = "text/javascript";
        script.src = arr[n].src;
        script.async = false;
        script.dataset.cfasync = false;  
        document.head.appendChild(script);
    }
    //document.getElementById("main_card").appendChild(payload.documentElement)
}
error_callback = function(payload){
    if(payload.code==400){
        var error_string = ""
        for (const error of payload._errors){
            error_string += `${error.fragment}: ${error.message}\n`
        }
       document.getElementById("errormessage").innerText = error_string
    }else if (payload.status==500){
        document.getElementById("errormessage").innerText = "500: Internal Server Error! Please contact us at support@applebee1558.com to discuss this bug!"
    }else{
        if (payload.message){
            document.getElementById("errormessage").innerText = payload.message
        }else{
            document.getElementById("errormessage").innerText = payload
        }
    }
}
donate = (amount)=>{
    var data = new FormData()
    data.append("amount", amount)
    Rails.ajax({url: "/donation/create_donation", data: data, success: success_callback, type: "POST", error: error_callback})
}
submit_paypal = function(url){
    window.location.href = url
}
go_back = () =>{
    window.location.href="/donation"
}